import React, { createContext, useContext } from 'react';
const OfferCardContext = /*#__PURE__*/createContext({
  requestedBy: 'Mobile',
  logUserEvent: e => console.log(e)
});
const useOfferCardContext = () => useContext(OfferCardContext);
const OfferCardContextProvider = _ref => {
  let {
    onDeepLink,
    requestedBy,
    children,
    logUserEvent,
    cardType
  } = _ref;
  return /*#__PURE__*/React.createElement(OfferCardContext.Provider, {
    value: {
      onDeepLink,
      requestedBy,
      logUserEvent,
      cardType
    }
  }, children);
};
export { OfferCardContextProvider, useOfferCardContext };
//# sourceMappingURL=OfferCardContext.js.map